/**
 * The fields dialog's row for a field edited in time (1.Y deliverable 5): while `chrono` is on, a
 * temporal field is the dated-field editor and a `world_date` field the world-date editor; with it
 * off (or before `auth.me` answers), 1.B-2's read-only line stays and nothing is requested.
 */
import type { FieldDefV1 } from '@codex/contracts';
import type { ReactNode } from 'react';
import { useChronoFlag } from '../when/calendar-context.js';
import { DatedFieldEditor, type RenderValueInput } from './dated-field-editor.js';
import { WorldDateEditor } from './world-date-editor.js';

export interface DatedFieldRowProps {
  readonly docId: string;
  readonly field: FieldDefV1;
  readonly readOnly: boolean;
  readonly renderValueInput: RenderValueInput;
  /** What shows with `chrono` off. */
  readonly fallback: ReactNode;
}

export function DatedFieldRow({
  docId,
  field,
  readOnly,
  renderValueInput,
  fallback,
}: DatedFieldRowProps) {
  const chrono = useChronoFlag();
  if (!chrono) return <>{fallback}</>;
  if (field.kind === 'world_date') {
    return <WorldDateEditor docId={docId} field={field} readOnly={readOnly} />;
  }
  if (field.temporal) {
    return (
      <DatedFieldEditor
        docId={docId}
        field={field}
        readOnly={readOnly}
        renderValueInput={renderValueInput}
      />
    );
  }
  return <>{fallback}</>;
}
